export const environment = {
  production: false,
  name: 'dev',
  url: 'https://api-uat.magnum.com.co/GeneralApi/',
  //url: 'http://localhost:5002/',

  portfolio: {
    url: 'https://api-uat.magnum.com.co/PortfolioApi/',
    //url: 'http://localhost:5003/',
    status: 'status',
    operation: {
      solution: 'solution',
      business: 'business',
      searchController: 'search',
      custom: 'custom',
      warehouseController: 'Warehouse',
       serialController: 'Serial',
    },
    payments:'payments'
  },
  report: {
    url: 'https://api-uat.magnum.com.co/ReportApi/',
    //url: 'http://localhost:5004/',
    billingElectronicController: 'billingElectronic',
    documetOperationController: 'documetOperation',
    documentDownloandController: 'documentDownloand',
    photoOperationController: 'photoOperation',
    customsClearanceReportController: 'customsClearanceReport',
    binnacleController: 'binnacle',
    soulBotController: 'soulBot',
    dataByChartController: 'DataByChart',
    quoteController: 'quote',
    taskServiceController: 'taskService',
    exchangeRateContoller: 'exchangeRate',
    homePageController: 'homepage',
    containerInquiry: 'ContainerInquiry/container-inquiry',
    yearController: 'year',
    custom: 'custom',

    configPage: {
      configPage: 'configPage/',
      kpiController: 'kpi',
      updateKpiController: 'updatekpis',
    },
    reportGeneratorController: 'ReportGenerator',
    hubNotification: 'hub/notifications',
    mainPagesController: 'mainpages'
  },

  authenticationController: 'authentication',
  changePasswordController: 'changePassword',
  oneTimePasswordController: 'oneTimePassword',
  recoverPasswordController: 'RecoveryPassword',
  userConfigController: 'userConfig',
  connectionController: 'connection',
  activityController: 'activity',
  statusActivityController: 'statusActivity',
  contactClientController: 'contactClient',
  trandlixController: 'trandlix',
  yearController: 'year',
  FrontComponentCountController: 'FrontComponentCount',
  actualDateController: 'date',
  CompanyController: 'Company',
  parameter: {
    WarehouseController: 'Warehouse',
    AutoCompleteController: 'AutoComplete',
  },
  processBackendController: 'processBackend',
  NotificationController: 'Notification',
};
